export default __webpack_public_path__ + "static/media/checkmark.d01f4d55.svg";